/* WHERE EACH BATCH OF VIDEOS SITS IN THE QUEUE.
 * ===========================================================================
 *
 * Utsav, 13 Oct 2026: "the first 5 pages will show the old 49 videos, and then
 * from the 5th and remaining pages we will show the intermediate 5 and the
 * recently processed 51 videos."
 *
 * So the queue is ordered by BATCH first (after the demo pin in featured.ts),
 * and only then by status and name, exactly as before, within each batch:
 *
 *   0  the original corpus — First Person Videos/<category>/<sub-category>/
 *      (49 videos, pages 1–5)
 *   1  First Person Videos/cut_720p/            (the 5 of run 20261009)
 *   2  First Person Videos/Egocentric_Videos/   (the 51 of run 20261012)
 *
 * A video is in a later batch when one FOLDER of its path is named exactly as
 * an entry below; the file name itself is never matched. Anything not listed is
 * batch 0 and keeps its old place.
 *
 * ADDING A FOLDER: append its folder name here; its videos then come after all
 * the ones above it. Without an entry a new folder's videos are mixed in with
 * the corpus, sorted by status and name.
 */
export const LATER_BATCHES: readonly string[] = [
  "cut_720p",            // run 20261009, 9 Oct
  "Egocentric_Videos",   // run 20261012, 12 Oct
];

/** 0 for the original corpus, 1 + the index in LATER_BATCHES otherwise. */
export function batchRank(path: string): number {
  const folders = path.split("/").slice(0, -1);
  for (let i = LATER_BATCHES.length - 1; i >= 0; i--) {
    if (folders.includes(LATER_BATCHES[i])) return i + 1;
  }
  return 0;
}
